module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "offset-y": "",
      "nudge-right": 10,
      "max-height": 400
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "div-button rounded",
          staticStyle: {
            "display": "flex"
          }
        }, on), [_c('img', {
          staticClass: "round",
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "width": "30",
            "height": "30",
            "src": _vm.image
          }
        }), _vm._v(" "), _c('div', {
          staticStyle: {
            "line-height": "1.5"
          }
        }, [_c('div', {
          staticStyle: {
            "xmargin-top": "-5px",
            "color": "#888",
            "font-size": "9px",
            "text-align": "left",
            "text-transform": "uppercase"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.label) + "\n              ")]), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-top": "-4px",
            "font-size": "14px"
          }
        }, [_vm._v(_vm._s(_vm.fullName(_vm.value)))])])])]
      }
    }], null, false, 761187896)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.users), function(user) {
    return _c('v-list-item', {
      key: user.uid,
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      staticStyle: {
        "height": "28px",
        "width": "28px"
      },
      attrs: {
        "src": user.image
      }
    })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.fullName(user)))])], 1)], 1)
  }), 1)], 1)], 1) : _c('div', [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "offset-y": "",
      "nudge-right": 10
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "div-button rounded display-flex"
        }, on), [_c('v-icon', {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "large": "",
            "color": "grey lighten-2"
          }
        }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-top": "5px",
            "color": "#888"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.label) + "\n          ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.users), function(user) {
    return _c('v-list-item', {
      key: user.uid,
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      staticStyle: {
        "height": "28px",
        "width": "28px"
      },
      attrs: {
        "src": user.image
      }
    })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(_vm.fullName(user)))])], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b19aa1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/UserChooser.vue
// module id = 2479
// module chunks = 1